import React from "react";
import HeaderGeneric from "../../../components/generic/headerGeneric";
import { CommandBar, ICommandBarItemProps } from "@fluentui/react";
export interface IHeaderGestionDocumentos {
  items: ICommandBarItemProps[];
  title: string;
  subTitle?: string;
  subTitle2?: string;
  estiloAux?: React.CSSProperties;
}
export const HeaderGestionDocumentos = ({
  items,
  title,
  subTitle2 = "",
  subTitle = "",
  estiloAux = {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 8px 20px 0px",
    //   alignItems: "center",
    //   border: "solid 1px red",
  },
}: IHeaderGestionDocumentos) => {
  return (
    <>
      <div style={estiloAux}>
        <div>
          <HeaderGeneric
            title={title}
            subTitle={subTitle}
            subTitle2={subTitle2}
            enabledicon={true}
          />
        </div>
        <div>
          <CommandBar
            items={items}
            farItems={[]}
            styles={{ root: { padding: "0px" } }}
          />
        </div>
      </div>
    </>
  );
};
